<mat-form-field class="w-100">
  @if (!this.label) {
    <mat-label>{{ 'Common.EmailChiplist.EmailAddresses' | translate }}</mat-label>
  }
  @if (this.label) {
    <mat-label>{{ label | translate }}</mat-label>
  }
  <mat-chip-grid #chipList multiple>
    @for (emailAddress of emailAddresses; track emailAddress) {
      <mat-chip-row [value]="emailAddress"
        (removed)="removeEmailAddress(emailAddress)">
        {{ emailAddress }}
        <button class="remove-button" matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input placeholder="{{ 'Common.EmailChiplist.EnterEmail' | translate }}" [matChipInputFor]="chipList" [matChipInputAddOnBlur]="true"
      [formControl]="emailAddressControl" (matChipInputTokenEnd)="addEmailAddressFromInput($event)">
  </mat-chip-grid>
  @if (chipList.errorState) {
    <mat-error>
      {{ 'Common.Validation.EmailPattern' | translate }}
    </mat-error>
  }
</mat-form-field>